import angular from 'angular';
import ModalLoaderService from './modalLoader.service';

let modalLoaderModule = angular.module('modalLoader', []).service('modalLoaderService', ModalLoaderService);

export default modalLoaderModule;



// WEBPACK FOOTER //
// ./app/common/modalLoader/modalLoader.js